// import Vue from 'vue'
// import Vuex from 'vuex'
import { returnDepartmentAndBtiByResponse } from './helpers.js'
import { executeHttpCall } from '@/services/httpClientHelper.js'
import { getPQDepartmentsAndGroups_WHI, getPQDepartmentsAndGroups_Warranty,getPQTGRDepartmentsAndGroups_Warranty,
  getPQPartDescSubGroup_v2_WHI, getPQPartDescSubGroup_v2_Warranty, getPQTGRPartDescSubGroup_v2_Warranty,
  getPQPartAll_WHI,getPQPartAll_Warranty, getPQTGRPartAll_Warranty,
  getPQReportTypes } from '@/services/importingJsons.js'

// Vue.use(Vuex)

const productQuality = {
  namespaced: true,
  state: {
    departments: {
      loading: false,
      error: false,
      options: []
    },
    btiCodes: {
      options: []
    },
    partDescriptions: {
      loading: false,
      error: false,
      options: []
    },
    parts: {
      loading: false,
      error: false,
      emptySearchResult: false,
      options: []
    },
    reportTypes: {
      loading: false,
      error: false,
      options: []
    },
    jsonInBackend: {
      data: null
    },
    selected: {
      customReportLink: null,
      repairSourceType: '',
      departments: [],
      btiCodes: [],
      partDescriptionObjects: [],
      partObjects: [],
      reportType: '',
      reportFormat: '',
      populationType: 'manual',
      autoSelect: false,
      partsAttachedViaFile: ''
    }
  },
  mutations: {
    departments (state, payload) {
      state.departments[payload.prop] = payload.value
    },
    btiCodes (state, payload) {
      state.btiCodes[payload.prop] = payload.value
    },
    partDescriptions (state, payload) {
      state.partDescriptions[payload.prop] = payload.value
    },
    parts (state, payload) {
      state.parts[payload.prop] = payload.value
    },
    reportTypes (state, payload) {
      state.reportTypes[payload.prop] = payload.value
    },
    selected (state, payload) {
      state.selected[payload.prop] = payload.value
    },
    jsonInBackend (state, payload) {
      state.jsonInBackend[payload.prop] = payload.value
    },
    overwriteSelected (state, newVal) {
      state.selected = newVal
    },
    setDefaultState (state) {
      state.departments = {
        loading: false,
        error: false,
        options: []
      }
      state.btiCodes = {
        options: []
      }
      state.partDescriptions = {
        loading: false,
        error: false,
        options: []
      }
      state.parts = {
        loading: false,
        error: false,
        emptySearchResult: false,
        options: []
      }
    },
    setDefaultSelectionState (state) {
      state.selected = {
        customReportLink: null,
        repairSourceType: '',
        departments: [],
        btiCodes: [],
        partDescriptionObjects: [],
        partObjects: [],
        reportType: '',
        reportFormat: '',
        populationType: 'manual',
        autoSelect: false,
        partsAttachedViaFile: ''
      }
    },
    setDefaultSearchSelectionState (state) {
      state.selected.departments = []
      state.selected.btiCodes = []
      state.selected.partDescriptionObjects = []
      state.selected.partObjects = []
      state.selected.partsAttachedViaFile = ''
    },
    setDefaultPartsSearchState (state) {
      state.parts = {
        loading: false,
        error: false,
        emptySearchResult: false,
        options: []
      }
      state.selected.partObjects = []
    }
  },
  getters: {
    getAllSelections: state => {
      return state.selected
    },
    shouldLoadPartsData: state => {
      return state.selected.partObjects.length > 0
    }
  },
  actions: {
    loadStateFromFile ({ commit, dispatch, getters, state }, data) {
      dispatch('reset')
      commit('overwriteSelected', data)
      dispatch('loadDepartmentData')
      dispatch('loadPartDescriptionData')
      if (getters.shouldLoadPartsData) dispatch('loadPartsData')
    },
    loadDepartmentData ({ commit, state }) {
      commit('departments', { prop: 'loading', value: true })
      commit('departments', { prop: 'error', value: false })

      const featureFunction = () => {
        switch (state.selected.repairSourceType) {
          case 'WHI': return getPQDepartmentsAndGroups_WHI()
          case 'WARRANTY_NEW': return getPQTGRDepartmentsAndGroups_Warranty()
          default: return getPQDepartmentsAndGroups_Warranty()
        }
      }
      featureFunction().then(response => {
        const responseParsed = returnDepartmentAndBtiByResponse(response)
        commit('departments', { prop: 'options', value: responseParsed.departmentList })
        commit('btiCodes', { prop: 'options', value: responseParsed.btiCodeList })
      }).catch(error => {
        console.error('Repair:getDepartments: ', error)
        commit('departments', { prop: 'error', value: true })
      }).finally(() => {
        commit('departments', { prop: 'loading', value: false })
      })
    },
    loadPartDescriptionData ({ commit, state }) {
      commit('partDescriptions', { prop: 'loading', value: true })
      commit('partDescriptions', { prop: 'error', value: false })

      const params = {
        resultFile: 'GetPQDsG',
        _program: 'GetPQPartDescSubGroup_v2',
        repairSourceType: state.selected.repairSourceType
      }
      const featureFunction = () => {
        switch (state.selected.repairSourceType) {
          case 'WHI': return getPQPartDescSubGroup_v2_WHI()
          case 'WARRANTY_NEW': return getPQTGRPartDescSubGroup_v2_Warranty()
          default: return getPQPartDescSubGroup_v2_Warranty()
        }
      }
      featureFunction().then(response => {
        commit('partDescriptions', { prop: 'options', value: response })
      }).catch(error => {
        console.error('Repair:getPartDescriptions: ', error)
        commit('partDescriptions', { prop: 'error', value: true })
      }).finally(() => {
        commit('partDescriptions', { prop: 'loading', value: false })
      })
    },
    loadPartsData ({ commit, state }) {
      commit('parts', { prop: 'loading', value: true })
      commit('parts', { prop: 'error', value: false })
      const data = {
        repairSourceType: state.selected.repairSourceType,
        partDescriptions: state.selected.partDescriptionObjects,
        subDepartments: state.selected.departments.map(x => x.split('-')[1]),
        subGroups: state.selected.btiCodes
      }
      const featureFunction = () => {
        switch (state.selected.repairSourceType) {
          case 'WHI': return getPQPartAll_WHI()
          case 'WARRANTY_NEW': return getPQTGRPartAll_Warranty()
          default: return getPQPartAll_Warranty()
        }
      }
      featureFunction().then(response => {
        var partResult = [] 
        var partResult_PartDescriptions = []
        var partResult_SubDepartments = []
        var partResult_BTI = []
        //Part Descriptions
          if(data.partDescriptions.length > 0){
            for (var i = 0; i < data.partDescriptions.length; i++) {
              for (var j = 0; j < response.length; j++) {
                if(response[j].part_desc === data.partDescriptions[i]){
                  var temp = response[j].Part_No.sort()
                  for (var k = 0; k < temp.length; k++) {
                    var obj = {}
                    obj["id"] = temp[k]
                    obj["label"] = response[j].part_desc
                    partResult_PartDescriptions.push(obj)

                  }
                }
              }
            }
          }
          //sub departments
          if(data.subDepartments.length > 0){
            for (var h = 0; h < data.subDepartments.length; h++) {
              for (var l = 0; l < response.length; l++) {
                if(response[l].Group.includes(data.subDepartments[h])){
                  var temp1 = response[l].Part_No.sort()
                  for (var t = 0; t < temp1.length; t++) {
                    var obj1 = {}
                    obj1["id"] = temp1[t]
                    obj1["label"] = response[l].part_desc
                    partResult_SubDepartments.push(obj1)

                  }
                }
              }
            }
          }
          //BTI structure
          if(data.subGroups.length > 0){
            for (var p = 0; p < data.subGroups.length; p++) {
              for (var g = 0; g < response.length; g++) {
                if(response[g].mainsubgroup_cd.includes(data.subGroups[p])){
                  var temp2 = response[g].Part_No.sort()
                  for (var s = 0; s < temp2.length; s++) {
                    var obj2 = {}
                    obj2["id"] = temp2[s]
                    obj2["label"] = response[g].part_desc
                    partResult_BTI.push(obj2)

                  }
                }
              }
            }
          }

          ///There are 3 arrays: Part Descriptions, Sub departments, BTI structure  and 9 combinations
          // 1 1 1 
          // 1 0 0 
          // 1 0 1  
          // 0 1 0 
          // 0 1 1  
          // 0 0 1  
          // 0 0 0 
          // 1 1 0 
          // 0 1 1
          if(partResult_PartDescriptions.length > 0 && 
            partResult_SubDepartments.length >  0 && 
            partResult_BTI.length > 0){
              partResult = partResult_PartDescriptions.filter(obj1 => {
              return partResult_SubDepartments.some(obj2 => obj2.id === obj1.id) && partResult_BTI.some(obj3 => obj3.id === obj1.id)
          })}
          if(partResult_PartDescriptions.length > 0 && 
            partResult_SubDepartments.length === 0 && 
            partResult_BTI.length === 0) {
              partResult = partResult_PartDescriptions
          }
          if(partResult_PartDescriptions.length > 0 && 
            partResult_SubDepartments.length === 0 && 
            partResult_BTI.length > 0) {
              partResult = partResult_PartDescriptions.filter(obj1 => {
                return partResult_BTI.some(obj3 => obj3.id === obj1.id)
              })
          }
          if(partResult_PartDescriptions.length === 0 && 
            partResult_SubDepartments.length > 0 && 
            partResult_BTI.length === 0) {
              partResult = partResult_SubDepartments
          }
          if(partResult_PartDescriptions.length === 0 && 
            partResult_SubDepartments.length > 0 && 
            partResult_BTI.length > 0) {
              partResult = partResult_SubDepartments.filter(obj1 => {
                return partResult_BTI.some(obj3 => obj3.id === obj1.id)
              })
          }
          if(partResult_PartDescriptions.length === 0 && 
            partResult_SubDepartments.length === 0 && 
            partResult_BTI.length > 0) {
              partResult = partResult_BTI
          }
          if(partResult_PartDescriptions.length > 0 && 
            partResult_SubDepartments.length >  0 && 
            partResult_BTI.length === 0){
              partResult = partResult_PartDescriptions.filter(obj1 => {
              return partResult_SubDepartments.some(obj2 => obj2.id === obj1.id)
          })}
          if(partResult_PartDescriptions.length === 0 && 
            partResult_SubDepartments.length >  0 && 
            partResult_BTI.length > 0){
              partResult = partResult_SubDepartments.filter(obj1 => {
              return partResult_BTI.some(obj2 => obj2.id === obj1.id)
          })}
        commit('parts', { prop: 'emptySearchResult', value: response.length === 0 })
        commit('parts', { prop: 'options', value: partResult })
      }).catch(error => {
        console.error('Repair:getPartsData: ', error)
        commit('parts', { prop: 'error', value: true })
      }).finally(() => {
        commit('parts', { prop: 'loading', value: false })
      })
    },
    loadReportTypesData ({ commit, state }) {
      commit('reportTypes', { prop: 'error', value: false })
      commit('reportTypes', { prop: 'loading', value: true })
      commit('reportTypes', { prop: 'options', value: [] })

      const params = {
        resultFile: 'GetPQRTy',
        _program: 'GetPQReportTypes'
      }
      getPQReportTypes(params, null).then(result => {
        commit('reportTypes', { prop: 'options', value: result })
        if (!state.selected.reportType || !state.selected.reportFormat) {
          const defaultSelected = result.find(x => x.PreSelected)
          commit('selected', { prop: 'reportType', value: defaultSelected ? defaultSelected.ReportTypeID : '' })
          commit('selected', { prop: 'reportFormat', value: defaultSelected ? defaultSelected.RepairSourceFormats[0] : '' })
        }
      }).catch(error => {
        console.error('Repair:getReportTypesData: ', error)
        commit('reportTypes', { prop: 'error', value: true })
      }).finally(() => {
        commit('reportTypes', { prop: 'loading', value: false })
      })
    },
    resetSearchSelections ({ commit }, selectionsOnly = false) {
      if (!selectionsOnly) {
        commit('setDefaultState')
      }
      commit('setDefaultSearchSelectionState')
    },
    resetPartsSearch ({ commit }) {
      commit('setDefaultPartsSearchState')
    },
    updateSelection ({ commit }, payload) {
      console.log('payload' + JSON.stringify(payload))
      commit('selected', payload)
    },
    reset ({ commit }) {
      commit('setDefaultState')
      commit('setDefaultSelectionState')
    }
  }
}
export default productQuality
